//@NOTE TRACK CHANGES OF BREAKPOINTS ALSO IN _functions.scss of theme styles

export const BREAKPOINTS = {
  XS: [0, 767],
  SM: [768, 1023],
  MD: [1024, 1279],
  ML: [1280, 1439],
  LG: [1440, 1919],
  XL: [1920, 3839],
  XXL: [3840],
  V4_XS: [0, 809],
  V$_SM: [810, 1199]
};